var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticStyle:{"display":"none"},attrs:{"id":"input_image","type":"file","accept":"image/jpg, image/png, image/jpeg"},on:{"change":_vm.input_file}})])
}
var staticRenderFns = []

export { render, staticRenderFns }